import { createApp } from 'vue'
import App from './App.vue'

document.title = "Lilian's Portfolio";

createApp(App).mount('#app')
